import _TopRight from 'src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import MultiLangDropDown from '@/src/constrains/SalesChannelMultiLanguageSelect/MultiLangDropDown';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { EnumMultiLanguageType } from 'src/constrains/SalesChannelMultiLanguageSelect';

const TopRight = (props) => {
  const { hasModified, onSubmit } = props;
  const { uuid }: any = useParams();

  const h = useHistory();
  const onD = () => {
    h.push(`/salesChannel/settings/${uuid}`);
  };
  return (
    <_TopRight
      onDiscard={onD}
      onSaveDisable={!hasModified}
      onSubmit={onSubmit}
      extraLeft={
        <div style={{ marginRight: 8 }}>
          <MultiLangDropDown
            customType={EnumMultiLanguageType.SalesChannelSettingsCheckout}
            hasModified={hasModified}
            salesChannelUuidKey='uuid'
          />
        </div>
      }
    />
  );
};
export default TopRight;
